import { Box } from '@mui/material'

type IconInfoProps = {
  Icon: any
  title: string
  value?: string
  component?: JSX.Element
}

const IconInfo = ({ Icon, title, value, component }: IconInfoProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%',
      inlineSize: '100%',
      overflowWrap: 'break-word',
    }}
  >
    <Icon
      sx={{
        color: 'var(--jy-navy-900, #00253d)',
        width: '32px',
      }}
    />
    <Box
      sx={{
        padding: '0',
        margin: '0',
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlign: 'left',
      }}
    >
      <Box
        component="p"
        sx={{
          color: 'var(--jy-navy-900, #00253d)',
          fontWeight: 600,
          fontSize: '11px',
          lineHeight: '1.27px',
          textTransform: 'uppercase',
        }}
      >
        {title}
      </Box>
      <Box
        component="p"
        sx={{
          color: '#3C4858',
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '21px',
        }}
      >
        {value}
        {component}
      </Box>
    </Box>
  </Box>
)

export default IconInfo
